import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";
import RadioGroup from "@mui/material/RadioGroup";

import { Badge, BadgeColors } from "@dotnet/telematics-design-system";

import Radio from "components/DesignComponents/Radio";
import { AUTHENTICATION_TYPES } from "shared/types/enums";

import { SelectAuthenticationMethodProps } from "../types";

const SelectAuthenticationType = ({
    type,
    isLoading,
    changeType
}: SelectAuthenticationMethodProps) => {
    const { t } = useTranslation();

    return (
        <RadioGroup
            value={type}
            onChange={e => changeType(e.target.value as AUTHENTICATION_TYPES)}
            sx={{
                rowGap: "16px"
            }}
        >
            <Radio
                value={AUTHENTICATION_TYPES.Authenticator}
                label={
                    <div
                        css={css({
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "wrap",
                            rowGap: "4px",
                            marginTop: "-2px",
                            marginBottom: "4px",

                            "& > span": {
                                display: "inline-block",
                                marginRight: "10px"
                            }
                        })}
                    >
                        <span>
                            {t("Security##2FA##title##authentication app")}
                        </span>

                        <Badge color={BadgeColors.info}>
                            {t(
                                "Security##2FA##select authentication type##recommended"
                            )}
                        </Badge>
                    </div>
                }
                info={t(
                    "Security##2FA##select authentication type##authentication app description"
                )}
                disabled={isLoading}
            />

            <Radio
                value={AUTHENTICATION_TYPES.Email}
                label={
                    <div
                        css={css({
                            marginBottom: "4px"
                        })}
                    >
                        {t("Security##2FA##select authentication type##email")}
                    </div>
                }
                info={t(
                    "Security##2FA##select authentication type##email description"
                )}
                disabled={isLoading}
            />
        </RadioGroup>
    );
};

export { SelectAuthenticationType };
